import useResendCodeTimer from "@casino/legacy/client/components/2faManaging/hooks/useResendCodeTimer";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import Button from "@casino/legacyUi/Button";

type Props = {
  onResendCodeClick: () => void;
};

const ResendCodeButton: FC<Props> = ({ onResendCodeClick }) => {
  const { handleResendClick, timeLeftFormatted, isTimeOver } =
    useResendCodeTimer(onResendCodeClick);

  if (isTimeOver) {
    return (
      <Button onClick={(event) => handleResendClick(event)} size="sm">
        <p className="text-sm leading-6 underline">
          <Translate id="profile.send_code_again" />
        </p>
      </Button>
    );
  }
  return (
    <p className="text-sm leading-6 text-muted-foreground">
      <Translate id="profile.resend_in" /> {timeLeftFormatted}
    </p>
  );
};

export default ResendCodeButton;
